import React from "react"
import ReactDOM from "react-dom"
import CarparkPricingSummaryComponent from "./carpark-pricing-summary-component"

export default class CarparkPricingSummaryModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.contentReferences = (elem.dataset.modelJson && JSON.parse(elem.dataset.contentReferences)) || "[]"
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <CarparkPricingSummaryComponent
        contentReferences={self.contentReferences}
        parkingProductsCards={self.modelJson.parkingProductCardContainer}
        resultsLabel={self.modelJson.resultsLabel}
        resultLabel={self.modelJson.resultLabel}
        defaultSortingLabel={self.modelJson.defaultSortingLabel}
        distanceShortToLongLabel={self.modelJson.distanceShortToLongLabel}
        distanceLongToShortLabel={self.modelJson.distanceLongToShortLabel}
        priceCheapToExpensiveLabel={self.modelJson.priceCheapToExpensiveLabel}
        priceExpensiveToCheapLabel={self.modelJson.priceExpensiveToCheapLabel}
        // {...self.modelJson}
      />,
      self.elem,
    )
  }
}
